import digi from '../../images/PortfolioImg/Digitizing/digi1.webp'

const DegitizingData = [
  {
    "id": 1,
    "name": "Flat Digitizing",
    "description": "Digitizing designs for flat embroidery, ideal for logos, text, and simple patterns on garments.",
    "pname": "digi",
    "image": digi
  },
  {
    "id": 2,
    "name": "3D Puff Digitizing",
    "description": "Digitizing designs for 3D puff embroidery, often used for raised logos on caps and jackets.",
    "pname": "digi",
    "image": digi
  },
  {
    "id": 3,
    "name": "Applique Digitizing",
    "description": "Digitizing designs for applique embroidery, combining fabric pieces with stitching for creative textures.",
    "pname": "digi",
    "image": digi
  },
  {
    "id": 4,
    "name": "Jacket Back Digitizing",
    "description": "Digitizing large and detailed designs specifically for the back of jackets or outerwear.",
    "pname": "digi",
    "image": digi
  },
  {
    "id": 5,
    "name": "Live Image Digitizing",
    "description": "Converting live or high-resolution images into precise embroidery stitch files.",
    "pname": "digi",
    "image": digi
  },
  {
    "id": 6,
    "name": "Pets Digitizing",
    "description": "Digitizing realistic pet portraits or animal designs for embroidery with fine detailing.",
    "pname": "digi",
    "image": digi
  }
]

export default DegitizingData
